import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/feathers-exposed-1080.webp'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<p>This text is not in Dutch, Google. Please stop asking to translate it!</p><img src=\"" + _imports_0 + "\" class=\"bg-image\"><div class=\"heck\"><h3>Clicky Stuff!</h3><nav><a href=\"https://twitch.tv/featherderg\" title=\"The place to watch the stream!\" target=\"_blank\" rel=\"noopener noreferrer\">Twitch</a> | <a href=\"https://bsky.app/profile/featherderg.net\" title=\"On to bluer skies, I guess...\" target=\"_blank\" rel=\"noopener noreferrer\">Bluesky</a> | <a href=\"https://www.youtube.com/@FeatheryFiddler\" title=\"Weird humansona, nerd!\" target=\"_blank\" rel=\"noopener noreferrer\">YouTube</a></nav><h6><small>(don&#39;t worry, they&#39;ll open in a new tab)</small></h6></div>", 3)
const _hoisted_4 = { class: "bottom" }
const _hoisted_5 = { class: "button-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuoteViewer = _resolveComponent("QuoteViewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_openBlock(), _createBlock(_Suspense, null, {
      fallback: _withCtx(() => [
        _createTextVNode("Loading...")
      ]),
      default: _withCtx(() => [
        _createVNode(_component_QuoteViewer)
      ]),
      _: 1
    })),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, "Noot n" + _toDisplayString("o".repeat(_ctx.count)) + "t!", 1),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.count++))
        }, "Noot")
      ])
    ])
  ], 64))
}